<div class="card-row">
  <div class="card-col">
    <app-contact-care-team *appShowFor="PermissionLevel.SEND_SECURE_MESSAGES"></app-contact-care-team>
    <app-contact-technical-support></app-contact-technical-support>
    <app-contact-treatment-facility></app-contact-treatment-facility>
  </div>
</div>
